<template>
    <div :ref="subjectSlug + '__' + post.slug" class="bg-white w-full rounded-md mb-4 py-3 px-6">
        <div class="item__header flex justify-between items-center cursor-pointer" :class="post.open === true ? 'pb-3' : ''" @click="toggleItem">
            <h3 class="item__header__title select-none" :class="post.open === true ? 'font-bold' : ''" v-html="post.title.rendered" />
            <plus v-if="post.open === false" :class="'item__header__plus'"/>
            <minus v-if="post.open === true" :class="'item__header__plus'"/>
        </div>

        <div v-if="post.open === true" class="item__body pt-9">
            <p v-html="post.content" class="item__body__text text-md prose"/>

            <Youtube v-if="post.acf.klantportaal_video_url" :code="post.acf.klantportaal_video_url"/>

            <a v-if="post.acf.klantportaal_url" :href="post.acf.klantportaal_url" class="item__body__btn btn font-normal text-white rounded-md px-4 py-2 lg:py-3 inline-block mt-6 w-full lg:w-auto text-center" target="_blank">{{  post.acf.button_text ? post.acf.button_text : $__('kennisbank.button_text') }}</a>
        </div>
    </div>
</template>

<script>
    import Plus from '@/Components/Icons/Plus';
    import Minus from '@/Components/Icons/Minus';
    import Youtube from '@/Components/Kennisbank/Youtube';

    export default {
        components: { Youtube, Minus, Plus },
        props: {
            post: Object,
            dataSubjectKey: Number,
            dataItemKey: Number,
            subjectSlug: String,
            preselectedSubjectSlug: String,
            preselectedPostSlug: String,
        },
        data: () => ({
            postWasPreSelected: false,
        }),
        methods: {
            toggleItem(changeParams = true) {
                this.$emit('toggleItem', this.$props.dataItemKey, this.$props.dataSubjectKey);

                if ( changeParams === false ) {
                    return;
                }

                this.$emit('updateUrlParams', this.subjectSlug, this.post.slug);
            },
        },
        created() {
            this.$props.post.open = false;
        },
        updated() {
            if (this.subjectSlug !== this.preselectedSubjectSlug ||
                this.post.slug !== this.preselectedPostSlug || this.postWasPreSelected !== false) {
                return;
            }

            this.toggleItem(false);
            this.postWasPreSelected = true;

            setTimeout(() => {
                const refKey = this.subjectSlug + '__' + this.post.slug;
                this.$emit('scrollIntoView', refKey, this.$refs)
            }, 100)
        }
    };
</script>
